import { Sparkles, ShieldCheck, Truck, RotateCcw, Phone, BadgeCheck } from "lucide-react";

/**
 * iter237 — Homepage trust strip.
 *
 * Five reasons-to-buy displayed below the SaleOffersTiles on home.
 * Boutique-light: soft ivory background, rosegold glyph chips, hairline
 * dividers. Designed to give every first-time visitor an immediate
 * "this is a real, trustworthy boutique" cue without screaming.
 */
const ITEMS = [
    {
        Icon: BadgeCheck,
        label: "Hand-curated",
        sub: "Every piece personally selected",
    },
    {
        Icon: Truck,
        label: "Pan-India delivery",
        sub: "Pin-code based ETA at checkout",
    },
    {
        Icon: ShieldCheck,
        label: "Secure payments",
        sub: "UPI · Cards · Netbanking · COD",
    },
    {
        Icon: RotateCcw,
        label: "Easy eligible returns",
        sub: "Return details shown on each piece",
    },
    {
        Icon: Phone,
        label: "Real-person support",
        sub: "WhatsApp · Call · Email",
    },
];

export default function HomeTrustStrip() {
    return (
        <section
            data-testid="home-trust-strip"
            className="mb-12 lg:mb-24 max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8"
        >
            <div className="rounded-[28px] bg-ivory-soft border border-stone-200/80 p-6 sm:p-8 lg:p-10 relative overflow-hidden">
                {/* Decorative glow */}
                <span
                    aria-hidden
                    className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-rosegold/10 blur-3xl pointer-events-none"
                />
                <p className="text-[10px] uppercase tracking-[0.32em] text-rosegold font-bold mb-5 flex items-center gap-3">
                    <Sparkles size={12} className="text-rosegold" />
                    Why women trust JnS
                </p>
                <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-5 gap-y-6">
                    {ITEMS.map((t, i) => (
                        <li
                            key={i}
                            data-testid={`home-trust-${i}`}
                            className="flex items-start gap-3 group"
                        >
                            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white text-rosegold border border-rosegold/20 flex-shrink-0 transition-transform group-hover:scale-110">
                                <t.Icon size={15} strokeWidth={1.6} />
                            </span>
                            <div className="min-w-0">
                                <p className="text-[12px] sm:text-[13px] font-semibold text-ink leading-tight">
                                    {t.label}
                                </p>
                                <p className="text-[10.5px] sm:text-[11px] text-ink-soft mt-0.5 leading-snug">
                                    {t.sub}
                                </p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
